import { useEffect, useRef } from 'react'

type Params = {
  key?: string
  condition?: boolean
  action: () => Promise<void> | void
}

export function useShortcutKeyWhen({ key = 'Enter', condition = true, action }: Params): null {
  const actionRef = useRef(action)

  useEffect(() => {
    actionRef.current = action
  })

  useEffect(() => {
    function onKeyDown(event: KeyboardEvent) {
      if (event.code === key && condition) actionRef.current()
    }

    document.addEventListener('keydown', onKeyDown)

    return () => document.removeEventListener('keydown', onKeyDown)
  }, [key])

  return null
}
